import styled from 'styled-components';
import { Card } from '@teals/ui-web';

export const Page = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 1.25rem;
  margin: 1rem 0 1.5rem;
  background: var(--warning-subtle, #fef3e8);
  border: 1px solid var(--warning, #d97706);
  border-radius: 10px;
  font-size: 0.875rem;
`;

export const OperatorBadgeRow = styled.p`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0 0 1rem;
`;

export const Subtitle = styled.p`
  color: var(--text-muted);
  margin: 0.25rem 0 0;
  font-size: 0.9375rem;
`;

export const ControlsBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: var(--bg-surface, var(--bg-elevated, transparent));
  border: 1px solid var(--border);
  border-radius: 10px;
`;

export const ControlLabel = styled.span`
  font-size: 0.75rem;
  color: var(--text-secondary, #64748b);
  margin-right: 0.25rem;
`;

export const RangeText = styled.span`
  margin-left: auto;
  font-size: 0.8125rem;
  color: var(--text-secondary, #64748b);
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const KpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.75rem;
  margin: 0 0 1.25rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const KpiCard = styled.div`
  background: var(--bg-surface, var(--bg-elevated, transparent));
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1rem 1.125rem;
`;

export const KpiLabel = styled.div`
  font-size: 0.75rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const KpiPeriodHint = styled.span`
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: var(--text-secondary, #64748b);
`;

export const KpiValue = styled.div`
  font-size: 1.35rem;
  font-weight: 600;
  margin-top: 0.35rem;
`;

export const PanelCard = styled(Card)`
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
`;

export const SectionTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
`;

export const SectionSub = styled.div`
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
`;

/** Compact 3-col platform defaults grid (Staff Pricing sketch). */
export const PricingDefaultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem 1rem;
  margin: 0.75rem 0 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const PricingDefaultsMeta = styled.p`
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin: 0 0 1rem;
`;

export const PricingSlideFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FieldTip = styled.p`
  font-size: 0.75rem;
  color: var(--text-muted);
  margin: 0.25rem 0 0;
  line-height: 1.35;
  font-weight: 400;
`;

export const SlideMetaRow = styled.div`
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  align-items: center;
`;

export const EffectiveThreshold = styled.div`
  padding: 0.75rem 1rem;
  background: var(--accent-subtle, rgba(45, 156, 139, 0.1));
  border-radius: 8px;
  font-size: 0.875rem;
  margin: 1rem 0;
`;

export const DiffBlock = styled.div`
  font-size: 0.875rem;
  margin: 0.75rem 0;
  line-height: 1.5;
`;

export const AuditNote = styled.div`
  font-size: 0.8125rem;
  color: var(--text-muted);
  background: var(--bg-elevated, var(--neutral-50, #f8fafc));
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin: 0.75rem 0 1rem;
`;

export const OrgIdHint = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  color: var(--text-muted);
`;

export const OrgNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
`;

export const SearchWrap = styled.div`
  max-width: 28rem;
  margin-bottom: 0.75rem;
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8125rem;
  color: var(--text-secondary);
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

export const SlideActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.25rem;
`;

export const Footnote = styled.p`
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin: 0.75rem 0 0;
`;
